export const DISPATCH_STATES = {
  CANCELLED: 9,
  DELIVERED: 8
};

export const DISPATCH_STATUS_LIST = {
  PENDING_PICKING: { value: "PENDING_PICKING", text: "PENDIENTE DE PICKING" },
  PENDING_DISPATCH: {
    value: "PENDING_DISPATCH",
    text: "PENDIENTE DE DESPACHO",
  },
  PENDING_RECEPTION: {
    value: "PENDING_RECEPTION",
    text: "PENDIENTE DE RECEPCION",
  },
  PENDING_CUSTOMER_COLLECT: {
    value: "PENDING_CUSTOMER_COLLECT",
    text: "PENDIENTE DE RECOJO CLIENTE",
  },
  PENDING_CUSTOMER_DISPATCH: {
    value: "PENDING_CUSTOMER_DISPATCH",
    text: "PENDIENTE DE DESPACHO CLIENTE",
  },
  PENDING_COLLECTION: {
    value: "PENDING_COLLECTION",
    text: "PENDIENTE DE RECOJO PROVEEDOR",
  },
  DISPATCHED: { value: "DISPATCHED", text: "VIAJE DESPACHADO A CLIENTE" },
  DELIVERED: { value: "DELIVERED", text: "ENTREGADO" },
  CANCELLED: { value: "CANCELLED", text: "CANCELADO" },
  PRE_CANCELLED: { value: "PRE_CANCELLED", text: "PRE-CANCELADO" },
  IN_TRANSIT: { value: "IN_TRANSIT", text: "EN TRANSITO" },
  TRIP_CREATED: { value: "TRIP_CREATED", text: "CREADO"},
  TRIP_IN_TRANSIT: { value: "TRIP_IN_TRANSIT", text: "EN TRANSITO"},
  TRIP_CANCELLED: { value: "TRIP_CANCELLED", text: "CANCELADO"},
  TRIP_FINISHED: { value: "TRIP_FINISHED", text: "FINALIZADO"}
};
